// File: src/EnglishTool/adjectivesPool.js

export function getAdjectivesPool(grade) {
    switch (grade) {
      case 1:
        // Grade 1 adjectives (simple)
        return [
          "big", "small", "happy", "sad", "hot",
          "cold", "fast", "slow", "red", "nice"
        ];
      case 2:
        // Grade 2 adjectives
        return [
          "big", "small", "happy", "sad", "red",
          "quick", "tall", "loud", "short", "bright"
        ];
      case 3:
        // Grade 3 adjectives
        return [
          "enormous", "tiny", "joyful", "upset", "silent",
          "clever", "brave", "gentle", "noisy", "friendly"
        ];
      case 4:
        // Grade 4 adjectives
        return [
          "brilliant", "dull", "lively", "timid", "generous",
          "awkward", "rapid", "furious", "cheerful", "curious"
        ];
      case 5:
        // Grade 5 adjectives
        return [
          "splendid", "dreadful", "cautious", "eager", "humble",
          "wise", "delightful", "exhausted", "faithful", "vibrant"
        ];
      case 6:
        // Grade 6 adjectives
        return [
          "elaborate", "genuine", "fierce", "radiant", "transparent",
          "minimal", "consistent", "widespread", "content", "versatile"
        ];
      case 7:
        // Grade 7 adjectives
        return [
          "intricate", "moderate", "exemplary", "obsolete", "dynamic",
          "precarious", "lavish", "fundamental", "zealous", "methodical"
        ];
      case 8:
        // Grade 8 adjectives
        return [
          "arduous", "prosperous", "meticulous", "vehement", "volatile",
          "reluctant", "unwavering", "quaint", "momentous", "sporadic"
        ];
      case 9:
        // Grade 9 adjectives
        return [
          "ambiguous", "rigorous", "relentless", "amiable", "robust",
          "coherent", "integral", "hypothetical", "ephemeral", "luminous"
        ];
      case 10:
        // Grade 10 adjectives
        return [
          "comprehensive", "elaborate", "intangible", "colossal", "feasible",
          "negligible", "concurrent", "inconsistent", "decisive", "impulsive"
        ];
      case 11:
        // Grade 11 adjectives
        return [
          "impeccable", "resolute", "precarious", "nuanced", "astute",
          "obscure", "incongruous", "lucid", "conspicuous", "efficacious"
        ];
      case 12:
        // Grade 12 adjectives
        return [
          "formidable", "transcendent", "quintessential", "paradoxical", "ubiquitous",
          "incredulous", "inexorable", "unassailable", "unequivocal", "incorrigible"
        ];
      default:
        // Fallback if grade doesn't match
        return [
          "big", "small", "happy", "sad", "red",
          "quick", "tall", "loud", "short", "bright"
        ];
    }
  }
  